<template>
    <v-container>
        <v-row>
            <v-card width="100%" class="mx-1">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card class="mt-4">
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard">Editar URL Acortada</v-toolbar-title>
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" md="7">
                        <v-row>
                            <v-col cols="12">
                                <span style="font-weight: bold;">URL Acortada:</span>
                                <v-text-field outlined width="20px" dense maxlength="7" readonly filled
                                    v-model="busqueda.short"></v-text-field>
                                <v-form ref="form" v-model="validForm" lazy-validation>
                                    <span style="font-weight: bold;">URL Completa:</span>
                                    <v-text-field outlined width="20px" dense v-model="busqueda.longUrl"
                                        :rules="rules"></v-text-field>
                                    <span style="font-weight: bold;">Sitio:</span>
                                    <multiselect v-model="busqueda.ntsitio"
                                        deselect-label="No se puede remover el valor seleccionado"
                                        selected-label="Seleccionado" select-label="Seleccione un estado de cita"
                                        track-by="saclave" label="sitio" placeholder="Seleccione un sitio"
                                        :options="Sitio.CatalogoSitios" :allow-empty="false">
                                    </multiselect>
                                    <span v-if="valSitio" style="color: #FF5C93; font-size: 11px">Campo
                                        requerido</span>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <div mt-2>
                    <v-btn class="mr-4" color="#536DFE" style="color:white" @click="actualizar()"
                        :disabled="btndis">Actualizar</v-btn>
                    <v-btn class="mr-4" color="secondary" style="color:white" @click="cancelar()"
                        :disabled="btndis">Cancelar</v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import Menu from '@/components/pages/Sistemas/MenuSistemas.vue';
import Sistemas from "@/services/Sistemas/sistemas.service.js";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        Menu,
    },
    data: function () {
        return {
            Sitio: {
                CatalogoSitios: [],
                ntsitio: '',
            },
            busqueda: {
                ntsitio: null,
                longUrl: null,
                short: null
            },
            val: 0,
            valSitio: false,
            validForm: true,
            rules: [
                v => !!v || 'Campo requerido',
            ],
            btndis: false,
            uslogin: null
        }
    },
    watch: {
        'busqueda.ntsitio'(val) {
            if (val != null) {
                this.valSitio = false;
            }
        }
    },
    async mounted() {
        this.uslogin = await MetodosGenerales.ObtenerUserName();
        let datos = await MetodosGenerales.obtenerSessionReporte("acortador");
        this.busqueda = {
            longUrl: datos.longUrl,
            short: datos.short,
            ntsitio: { saclave: datos.sitio, sitio: "s" },
            aclave: datos.aclave
        },
            await Sistemas.CatalogoAcortador(this);

    },
    methods: {
        cancelar() {
            this.$router.push({ name: 'AcortadorBusqueda' }).catch((error) => error);
        },
        async validar() {
            this.val = 0;
            this.$refs.form.validate()
            if (this.busqueda.ntsitio == null) {
                this.valSitio = true;
                this.val++;
            }
            if (this.busqueda.longUrl == null) {
                this.val++;
            }
        },
        async actualizar() {
            await this.validar();
            if (this.val == 0) {
                this.$swal({
                    title: 'Actualizando URL, espere, por favor.',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        this.btndis = true;
                        let response = await Sistemas.EditarURLAcortada(this.busqueda.ntsitio.saclave, this.busqueda.longUrl.trim(), this.busqueda.aclave, this.uslogin);
                        if (response == true) {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'URL Acortada actualizada correctamente.',
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                this.$router.push({ name: 'AcortadorBusqueda' }).catch((error) => error);
                            });
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Error',
                                text: 'Ocurrió un error al actualizar la URL, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: false,
                                timer: 2500
                            });
                            this.btndis = false;
                        }
                    }

                })
            }

        }
    }
}
</script>

<style></style>